import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as BurgerIcon } from '../../../../../resource/Burger.svg';
import { ReactComponent as CameraIcon } from '../../../../../resource/CameraIcon.svg';
import { housesViews } from '../../../constants/housesViews';
import { setHousesView } from '../../../store/actions/housingStockActions';
import ViewTabs from '../../common/ViewTabs/ViewTabs';

const viewTabsItems = [
  {
    key: housesViews.list,
    renderIcon: ({ className }) => <BurgerIcon className={className} />,
  },
  {
    key: housesViews.cameras,
    renderIcon: ({ className }) => <CameraIcon className={className} />,
  },
];

const HousesViewTabs = ({ className }) => {
  const housesView = useSelector((state) => state.housingStockStore.housesView);

  const dispatch = useDispatch();

  const handleChange = (_evt, newValue) => {
    if (newValue !== housesView) {
      dispatch(setHousesView(newValue));
    }
  };

  return (
    <ViewTabs
      value={housesView}
      onChange={handleChange}
      items={viewTabsItems}
      className={className}
    />
  );
};

export default HousesViewTabs;
